import React from "react";
import {Image} from "primereact/image";
import photo from "./photo.png";
import {Divider} from "primereact/divider";

const AboutMe = () => {
  return (
    <>
      <hr />
      <div className='card'>
        <div className='content'>
          <Image src={photo} alt='M.Serkan ÇINAR' width='150' />
          <br /> I am currently working as Chief Researcher at the Energy
          Technologies, Marmara Research Center, TUBITAK, Ankara. I am also
          part-time lecturer at Department of Software Engineering at Cankaya
          University.
          <br />
          Some of the projects I've worked as a Software Engineer are;
          <ul>
            <li>
              TEKİS:TEİAŞ ELECTRIC POWER QUALITY AND GRID MONITORING SYSTEM{" "}
              <a href='https://tekis.teias.gov.tr/tekis/'> More Info</a>
            </li>
            <li>
              ATHOM: RIVER FLOW FORECAST AND BASIN OPTIMIZATION MODEL{" "}
              <a href='https://enerji.mam.tubitak.gov.tr/tr/arastirma-alanlari/enerji-izleme-ve-tahmin-0'>
                More Info
              </a>
            </li>
            <li>
              HVBS: TUAF BATTLE MANAGEMENT CIS DIVISION{" "}
              <a href='https://www.havelsan.com.tr/sektorler/savunma-ve-guvenlik/hava/stratejik-c2is/havelsan-hvbs-meis'>
                More Info
              </a>
            </li>
            <li>
              MIYE: CIVIC TRAINING FOR MEHMETCIK{" "}
              <a href='https://www.ab.gov.tr/civic-training-for-mehmetcik-conscrpits-_52848_en.html'>
                More Info
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AboutMe;
